export default "__VITE_ASSET__Cckeyd2y__"